import type { PublicationRow } from "../data/mockData";
import { publicationProgressPercent } from "./publicationProgress";

export function sortPublications(pubs: PublicationRow[], sortBy: string): PublicationRow[] {
  const result = [...pubs];

  result.sort((a, b) => {
    switch (sortBy) {
      case "name_desc":
        return b.name.localeCompare(a.name);
      case "progress_desc": {
        const pctA = publicationProgressPercent(a);
        const pctB = publicationProgressPercent(b);
        if (pctA === undefined) return pctB === undefined ? 0 : 1;
        if (pctB === undefined) return -1;
        return pctB - pctA;
      }
      case "progress_asc": {
        const pctA = publicationProgressPercent(a);
        const pctB = publicationProgressPercent(b);
        if (pctA === undefined) return pctB === undefined ? 0 : 1;
        if (pctB === undefined) return -1;
        return pctA - pctB;
      }
      default:
        return a.name.localeCompare(b.name);
    }
  });

  return result;
}
